<template>
  <div class="dashboard-page-wrapper dashboard-page">
    <ChartInputs />
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import ChartInputs from "@/components/layout/Dashboard/ChartInputs.vue";
export default {
  components: {
    ChartInputs,
  },
  name: "Main",
};
</script>